<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @showDetail="showDetail"
      @batchListing="onBatchListing"
      @bulkDeactivation="onBulkDeactivation"
      @batchRecovery="onBatchRecovery"
      @checkboxChange="(e) => (checkedRow = e)"
    >
      <page-header
        ref="header"
        slot="header"
        :checked-count="checkedCount"
        @query="getData"
        @reset="resetPage"
        @putShelves="putShelvesVisible = true"
        @batchListing="batchListing"
        @bulkDeactivation="bulkDeactivation"
        @batchRecovery="batchRecovery"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <PutShelves :visible.sync="putShelvesVisible" @reload="reload" />
    <Detail
      :visible.sync="detailVisible"
      :invSkuSetCode="invSkuSetCode"
      :disabled="disabled"
      :title="title"
      @reload="reload"
    />
  </div>
</template>
<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageHeader from './header'
import PageMain from './main.vue'
import PutShelves from '../put-shelves'
import Detail from '../detail'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, PutShelves, Detail },
  data() {
    return {
      usePage: true,
      checkedRow: [],
      putShelvesVisible: false,
      detailVisible: false,
      invSkuSetCode: '',
      disabled: false,
      title: '',
    }
  },
  computed: {
    checkedCount() {
      return !this.checkedRow ? 0 : this.checkedRow.length
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomOverseasInvSkuSetListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.checkedRow = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    batchListing() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_batch_listing') || '请选择需要上架的SKU',
          type: 'warning',
        })
        return
      }
      const codes = this.checkedRow.map((item) => item.invSkuSetCode)
      this.onBatchListing(codes)
    },
    onBatchListing(codes) {
      this.$confirm(
        this.$l('tips_confirm_batch_listing') ||
          '是否要将选择中的记录修改为上架',
        this.$l('tip_confirm_batch_listing_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_batch_listing_confirm') || '确定',
          cancelButtonText: this.$l('btn_batch_listing_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvSkuSetAvailableApi({ codes })
          .catch(() => null)
        this.loadingClose()
        const { status, msg } = res || {}
        if (status !== 200 && status === 203) {
          this.$alert(
            msg,
            this.$l('tip_confirm_batch_listing_title') || '确认信息',
            {
              confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
              type: 'error'
            }
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_available_listing_ok') || '上架成功！',
          type: 'success',
        })
        this.reload()
      })
    },
    bulkDeactivation() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_batch_listing') || '请选择需要停用的SKU',
          type: 'warning',
        })
        return
      }
      const codes = this.checkedRow.map((item) => item.invSkuSetCode)
      this.onBulkDeactivation(codes)
    },
    onBulkDeactivation(codes) {
      this.$confirm(
        this.$l('tips_confirm_bulk_deactivation') || '是否要将选择中的记录停用',
        this.$l('tip_confirm_bulk_deactivation_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_bulk_deactivation_confirm') || '确定',
          cancelButtonText: this.$l('btn_bulk_deactivation_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvSkuSetDeactivateApi({ codes })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(
            this.$l('tips_available_update_no') || '修改失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_available_update_ok') || '修改成功！',
          type: 'success',
        })
        this.reload()
      })
    },
    batchRecovery() {
      if (!this.checkedCount) {
        this.$message({
          message:
            this.$l('tips_please_batch_listing') || '请选择需要恢复的SKU',
          type: 'warning',
        })
        return
      }
      const codes = this.checkedRow.map((item) => item.invSkuSetCode)
      this.onBatchRecovery(codes)
    },
    onBatchRecovery(codes) {
      this.$confirm(
        this.$l('tips_confirm_batch_recovery') || '是否要恢复选择中的记录',
        this.$l('tip_confirm_batch_recovery_title') || '确认信息',
        {
          confirmButtonText: this.$l('btn_batch_recovery_confirm') || '确定',
          cancelButtonText: this.$l('btn_batch_recovery_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .ecomOverseasInvSkuSetRestorationApi({ codes })
          .catch(() => null)
        this.loadingClose()
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(
            this.$l('tips_available_recovery_no') || '恢复失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('tips_available_recovery_ok') || '恢复成功！',
          type: 'success',
        })
        this.reload()
      })
    },
    showDetail({ invSkuSetCode, disabled, title }) {
      this.detailVisible = true
      this.disabled = disabled
      this.title = title
      this.invSkuSetCode = invSkuSetCode
    },
  },
}
</script>
